import React from "react";
import Link from "helpers/link";
import { ReactComponent as ReviewsIO } from "assets/svgs/reviews-io.svg";
import { ReactComponent as Stars } from "assets/svgs/stars.svg";
import { ReactComponent as YellowStars } from "assets/svgs/yellow-stars.svg";
import { useGlobalContext } from "context/global";

const Horizontal = ({ reviews }) => (
	<div className="w-3/4 flex m-auto mt-7 justify-between items-center md:w-[40%] lg:w-1/5">
		<ReviewsIO role="presentation" aria-hidden="true" />
		<span className="text-base">{reviews?.store?.average}</span>
		<Stars role="presentation" aria-hidden="true" />
	</div>
);

const Vertical = ({ reviews }) => (
	<div className="w-3/4 flex flex-col justify-between items-center">
		<ReviewsIO />
		<div className="flex justify-around items-center w-full mt-2">
			<span className="text-base">{reviews?.store?.average}</span>
			<Stars />
		</div>
	</div>
);

const Normal = ({ reviews, translation }) => (
	<Link to="/reviews" className="w-full flex flex-col justify-between items-center">
		<div className="flex justify-center items-center flex-col md:flex-row">
			<YellowStars className="w-[30%] md:w-[18%] md:mr-12 mb-2 md:mb-0" />
			<p className="text-sm md:text-lg/5">
				<span className="text-sm md:text-lg/5 font-boldParagraph">
					{reviews?.store?.average} ‘{translation.other?.excellent}’
				</span>
				{translation.other?.basedOn} {reviews?.store?.total.toLocaleString("de-DE")} {translation.other?.reviews}
			</p>
		</div>
	</Link>
);

const Default = ({ reviews, translation }) => (
	<Link to="/reviews" className="w-full flex flex-col justify-between items-center mb-3">
		<div className="flex justify-center items-center mt-2 flex-col md:flex-row">
			<div className="flex md:contents justify-center items-center mb-1">
				<span className="text-base mr-2 font-boldParagraph">{translation.other?.excellent}</span>
				<YellowStars className="!w-1/4 md:!w-1/6 mr-2" />
			</div>
			<p className="text-sm">
				<span className="text-base font-boldParagraph">
					{reviews?.store?.average}
				</span> {translation.other?.basedOn}
				<span className="text-base font-boldParagraph">
					{reviews?.store?.total.toLocaleString("de-DE")}
				</span> {translation.other?.reviews}
			</p>
		</div>
	</Link>
);

const TotalReviews = ({ direction = "horizontal" }) => {
	const { translation, reviews } = useGlobalContext();

	if (!reviews) return <></>;

	switch (direction) {
		case "horizontal":
			return <Horizontal reviews={reviews} />;
		case "vertical":
			return <Vertical reviews={reviews} />;
		case "default":
			return <Default reviews={reviews} translation={translation} />;
		default:
			return <Normal reviews={reviews} translation={translation} />;
	}

};

export default TotalReviews;
